import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'upsell-option-modal',
  templateUrl: './upsell-option-modal.component.html',
  styleUrl: './upsell-option-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsellOptionModalComponent {
  @Input() upgradePricePerPassenger = 0;

  ValueEnum = ValueEnum;

  features = [
    {
      image: 'airplane',
      label: 'Delays & Disruption assistance',
      values: { basic: ValueEnum.False, essential: ValueEnum.True },
    },
    {
      image: 'ticket',
      label: 'Voluntary cancelation',
      values: { basic: ValueEnum.False, essential: ValueEnum.True },
    },
    {
      image: 'calendar',
      label: 'Voluntary Change',
      values: { basic: ValueEnum.Currency, essential: ValueEnum.True },
    },
    {
      image: 'headphones',
      label: 'Post-booking assistance',
      values: { basic: ValueEnum.Currency, essential: ValueEnum.True },
    },
  ];

  @Output() hideModal = new EventEmitter();
  @Output() upgrade = new EventEmitter();
  @Output() continue = new EventEmitter();
  @Output() review = new EventEmitter();
}

enum ValueEnum {
  False = '✕',
  True = '✓',
  Currency = '$',
}
